export default {
    namespaced: true,
    state: {
        version: 'dummy',
        inputs: {
            basic: {
                text: '',
                sequence: 0
            },
            dhusor: {
                text: '',
                sequence: 0
            },
            shobdopata: {
                text: '',
                sequence: 0
            },
            shuvro: {
                text: '',
                sequence: 0
            },
            dummy: {
                text: 'Dummy text',
                sequence: 0
            }
        },
        outputs: {
            basic: {
                text: '',
                sequence: 0,
                suggestions: []
            },
            dhusor: {
                text: '',
                sequence: 0,
                suggestions: []
            },
            shobdopata: {
                text: '',
                sequence: 0,
                suggestions: []
            },
            shuvro: {
                text: '',
                sequence: 0,
                suggestions: []
            },
            dummy: {
                text: '',
                sequence: 0,
                suggestions: []
            }
        }
    },

    mutations: {
        UPDATE_INPUT (state, { text, sequence }) {
            if (sequence < state.inputs[state.version].sequence) {
                return;
            }
            state.inputs[state.version].text = text;
            state.inputs[state.version].sequence = sequence;
        },

        UPDATE_OUTPUT (state, { text, sequence, suggestions }) {
            if (sequence < state.outputs[state.version].sequence) {
                return;
            }
            state.outputs[state.version].text = text;
            state.outputs[state.version].sequence = sequence;
            state.outputs[state.version].suggestions = suggestions || [];
        },

        UPDATE_VERSION (state, version) {
            state.version = version;
        },

        UPDATE_SUGGESTIONS_SELECTION (state, { index, value }) {
            let output = state.outputs[state.version];
            output.suggestions[index].selected = value;

            let text = '';
            for (let i = 0; i < output.suggestions.length; i++) {
                let selected = output.suggestions[i].selected || 0;
                text += output.suggestions[i].options[selected];
            }
            output.text = text;
        }
    }
};
